export function StatusBadge({ status }: { status: "Pending" | "Acknowledged" }) {
  const cls = status === "Pending" ? "badge-pending" : "badge-acknowledged";
  return (
    <span className={cls} aria-label={`Status: ${status}`}>
      {status}
    </span>
  );
}
